import { ArrowUpRight } from "lucide-react";
import { track } from "@/lib/analytics";

/** Hero credibility line: "As covered in Forbes" linking Dr. Evans' column.
 *  Static by design: /api/news is subscriber-dashboard only (owner decision,
 *  Feb 2026), so public pages must not call it. */
export const ForbesHeroLine = () => {
  return (
    <a
      href="https://www.forbes.com/sites/tonyaevans/"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="hero-forbes-line"
      onClick={() => track("news_item_click", { source: "hero_forbes" })}
      className="group mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 max-w-xl"
    >
      <span className="shrink-0 inline-flex items-center gap-1.5 bg-ink text-white px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em]">
        As covered in Forbes
      </span>
      <span className="font-serif italic text-sm text-ink/85 leading-snug group-hover:text-blueprint transition-colors">
        {"Dr. Evans on digital-asset law and policy"}
        <ArrowUpRight size={12} strokeWidth={1.75} className="inline-block ml-1 align-baseline opacity-60 group-hover:opacity-100 transition-opacity text-blueprint" />
      </span>
    </a>
  );
};
